module.exports = require('./commonjs/readXlsxFileBrowser').default